// This file is automatically generated. Do not edit manually.

import { CatalogPartRevisionView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SitePartRevisionEditApi {
	export async function getFormInitData(args: {
		partRevisionId: number;
	}): Promise<SitePartRevisionEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/warehouse/part/revision/edit/getFormInitData",
			method: "POST",
			data: {
				partRevisionId: args.partRevisionId,
			},
		});
		return response as SitePartRevisionEditApi_FormInitData;
	}

	export async function update(args: { partRevisionId: number; note: string }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/warehouse/part/revision/edit/update",
			method: "POST",
			data: {
				partRevisionId: args.partRevisionId,
				note: args.note,
			},
		});
		return response as void;
	}
}

export interface SitePartRevisionEditApi_FormInitData {
	catalogPartRevision: CatalogPartRevisionView;
}
